import { useMutation } from "@tanstack/react-query";

async function sendMagicLinkRequest(email: string, slug: string) {
  fetch(`${import.meta.env.VITE_AGENCY_API_URL}login`, {
    method: "POST",
    headers: {
      "Content-Type": `application/json`,
    },
    body: JSON.stringify({
      email,
      slug,
    }),
  });
}

export default function useWhitelabelMutations() {
  const { mutateAsync: sendMagicLink, isPending: isSendingMagicLink } =
    useMutation({
      mutationFn: ({ email, slug }: { email: string; slug: string }) =>
        sendMagicLinkRequest(email, slug),
    });

  return {
    sendMagicLink,
    isSendingMagicLink,
  };
}
